module.exports = __webpack_public_path__ + "media/src/images/award_land_der_ideen-b717a353c124b3eadc666fcd345007bf.jpg";